import type { BusinessPlanRole } from "../business/plan/BusinessPlanModel";

export enum Permission {
  AccessToEverything,
  AccessToAdminPage,
  TasksAlwaysAccessible,
  ShoutoutsVisible,
  CanManageFeedItems,
  CanEditModules,
  CanEditSections,
  CanEditSchedules,
  AvatarShowExtraBorder,
}

export const getRoles = (): BusinessPlanRole[] => {
  // Return predefined roles in prio order of display, last displays first
  return [
    {
      name: "admin",
      displayName: "Admin",
      color: "#000",
      emoji: "👤",
      permissions: [Permission.AccessToEverything],
    },
    {
      name: "moderator",
      displayName: "Moderator",
      color: "$pressablePrimaryBackground",
      emoji: "✋",
      permissions: [
        Permission.AvatarShowExtraBorder,
        Permission.TasksAlwaysAccessible,
        Permission.CanManageFeedItems,
        Permission.CanEditSections,
      ],
    },
    {
      name: "host",
      displayName: "Host",
      color: "$pressablePrimaryBackground",
      emoji: "👑",
      permissions: [
        Permission.ShoutoutsVisible,
        Permission.AvatarShowExtraBorder,
      ],
    },
    {
      name: "guide",
      displayName: "Guide",
      color: "$pressablePrimaryBackground",
      emoji: "👑",
      permissions: [
        Permission.ShoutoutsVisible,
        Permission.AvatarShowExtraBorder,
      ],
    },
  ];
};

export const allRoles = getRoles();
